const afterPathnameKey = (traffic, key) => {
  const urlObject = new URL(traffic.url.toLowerCase())
  const pathnameParts = urlObject.pathname.split('/')
  return pathnameParts[pathnameParts.indexOf(key) + 1]
}

export default afterPathnameKey



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/selectors/afterPathnameKey.js